var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembersLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10h-1.8m-.836 6.364-1.273-1.273M2.8 10H1m3.909-5.091L3.636 3.636M10 2.8V1m5.091 3.909 1.273-1.273M10 19v-1.8m-6.364-.836 1.273-1.273M10 5.5l1.39 2.817 3.11.454-2.25 2.192.531 3.096L10 12.597l-2.781 1.462.531-3.096L5.5 8.772l3.11-.455L10 5.5z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersLight);
export default __webpack_public_path__ + "static/media/members-light.7585c43ab87d30036b9db57e3d46b57b.svg";
export { ForwardRef as ReactComponent };